export function replaceSymbols(str){
    return str.toLowerCase()
        .replace(new RegExp(' ', 'g'), '_')
        .replace(new RegExp('õ', 'g'), 'o')
        .replace(new RegExp('ä', 'g'), 'a')
        .replace(new RegExp('ö', 'g'), 'o')
        .replace(new RegExp('ü', 'g'), 'u');
}


// WEBPACK FOOTER //
// ./src/utils/stringFuncs.js